'use strict';

(function (angular) {
  angular.module('zp').controller('HoneyMoonGalleryController', honeyMoonGalleryController);

  /**ngInject */
  function honeyMoonGalleryController($uibModalInstance, $timeout, honeyMoon, index) {
    var vm = this;
    vm.index = 0;
    vm.gallery = honeyMoon.gallery;

    (function () {
      $timeout(function () {
        vm.index = index;
      }, 250);
    })();
  }
})(window.angular);